"use client"

import styles from "./styles/DashboardPage.module.scss"
import DraftPagesWidget from "./DraftPagesWidget";
import {ContentItemApprovalWidget} from "./ContentItemApprovalWidget";

export default function UserDashboardPage(props) {
    return <div className={styles.body}>
        <ContentItemApprovalWidget />
        <DraftPagesWidget />
    </div>
}
